<template>
  <div id="content" class="content-wrapper home-launcher">
    <b-container fluid>
      <header class="home-launcher__header">
        <div class="home-launcher__logo-wrap">
          <img
            src="@/assets/images/logo_colorido.png"
            alt="Grupo Polgo"
            class="home-launcher__logo"
          />
        </div>
        <h1 class="home-launcher__greeting">Olá, {{ userName }}</h1>
        <p class="home-launcher__subtitle">Toque em um atalho ou digite "Ctrl + P" para pesquisar</p>
      </header>

      <home-shortcut-grid
        v-if="availableShortcuts.length"
        :shortcuts="availableShortcuts"
        @action="handleShortcutAction"
      />

      <empty-state
        v-else
        title="Nenhum atalho disponível"
        message="Você ainda não tem permissão para acessar as telas do Configurador."
        icon="fas fa-lock"
      />
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getHomeShortcuts } from '@/lib/homeShortcuts';
import { mapOAuthAtalhosToShortcuts } from '@/lib/oauthAppFormUtils';
import HomeShortcutGrid from '@/components/home/HomeShortcutGrid.vue';
import EmptyState from '@/components/layout/EmptyState.vue';

const ROOT_ACTIONS = {
  openQuickSearch: 'open-quicksearch',
  openInicializarSistema: 'open-inicializar-sistema',
};

export default {
  name: 'home',
  components: {
    HomeShortcutGrid,
    EmptyState,
  },
  data() {
    return {
      oauthShortcuts: [],
    };
  },
  computed: {
    ...mapGetters({
      user: 'autenticacao/getUser',
      userPermissions: 'autenticacao/getUserPermissions',
      supervisionados: 'supervisao/getSupervisionados',
    }),
    userName() {
      if (!this.user) {
        return 'Usuário';
      }
      return this.user.descricao || this.user.nome || this.user.usuario || 'Usuário';
    },
    availableShortcuts() {
      const internal = getHomeShortcuts(this.userPermissions, {
        supervisionados: this.supervisionados,
      });
      return [...internal, ...this.oauthShortcuts];
    },
  },
  async mounted() {
    document.title = 'Home';
    await this.$store.dispatch('supervisao/fetchSupervisionados');
    await this.carregarAtalhosOAuth();
  },
  methods: {
    ...mapActions({
      listarAtalhos: 'oauth/listarAtalhos',
    }),
    async carregarAtalhosOAuth() {
      const response = await this.listarAtalhos();
      if (response.status === 200) {
        this.oauthShortcuts = mapOAuthAtalhosToShortcuts(response.dados?.atalhos || []);
      }
    },
    handleShortcutAction(action) {
      const eventName = ROOT_ACTIONS[action];
      if (eventName) {
        this.$root.$emit(eventName);
      }
    },
  },
};
</script>

<style scoped>
.home-launcher {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: flex-start;
  padding-top: var(--spacing-lg);
}

.home-launcher__header {
  text-align: center;
  margin-bottom: var(--spacing-lg);
}

.home-launcher__logo-wrap {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-bottom: var(--spacing-md);
}

.home-launcher__logo {
  width: auto;
  max-width: 180px;
  height: auto;
  display: block;
}

.home-launcher__greeting {
  margin: 0 0 var(--spacing-xs);
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
}

.home-launcher__subtitle {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
}
</style>
